import BonDeLivraison from '@/entities/BonDeLivraison';
import BDLProduct from '@/entities/BDLProduct';
import firebase from 'firebase';

export default class BDLService {
  constructor(db) {
    this.db = db;
  }

  async listBySupplierAndShopId(supplierId, shopId) {
    console.log(supplierId, shopId);
    const snap = await this.db
      .collection('bonsDeLivraison')
      .where('supplierId', '==', supplierId)
      .where('shopId', '==', shopId)
      .orderBy('createdAt', 'desc')
      .get();
    const list = [];
    snap.forEach((doc) => list.push(new BonDeLivraison({ ...doc.data(), id: doc.id })));
    console.log('list', list);
    console.log(JSON.parse(JSON.stringify(list)));
    return list;
  }

  beforeCreate(bonDeLivraison) {
    const cpy = { ...bonDeLivraison };
    console.log(this.db.constructor);
    if (!cpy.createdAt) {
      cpy.createdAt = firebase.firestore.FieldValue.serverTimestamp();
    }
    if (!cpy.deliveryExpectedAt) {
      cpy.deliveryExpectedAt = firebase.firestore.FieldValue.serverTimestamp();
    }
    return cpy;
  }

  async create(bonDeLivraison) {
    const transformed = JSON.parse(JSON.stringify(bonDeLivraison));
    const toSave = this.beforeCreate(transformed);
    const snap = await this.db.collection('bonsDeLivraison').doc(bonDeLivraison.ref).set(toSave);
    return { ...bonDeLivraison, id: snap.id };
  }

  async updateById(id, bonDeLivraison) {
    await this.db.collection('bonsDeLivraison').doc(id).update(bonDeLivraison);
    return bonDeLivraison;
  }

  async getById(id) {
    const snap = await this.db.collection('bonsDeLivraison').doc(id).get();
    if (!snap.exists) { return null; }
    return new BonDeLivraison({ ...snap.data(), id: snap.id });
  }

  async upsertById(id, bonDeLivraison) {
    const transformed = JSON.parse(JSON.stringify(bonDeLivraison));
    const toSave = this.beforeCreate(transformed);
    await this.db
      .collection('bonsDeLivraison')
      .doc(id)
      .set(toSave, { merge: true });
    return bonDeLivraison;
  }

  async getBySupplierAndRefId(supplierId, ref) {
    const snap = await this.db
      .collection('bonsDeLivraison')
      .where('supplierId', '==', supplierId)
      .where('ref', '==', ref)
      .limit(1)
      .get();
    const list = [];
    snap.forEach((doc) => list.push(new BonDeLivraison({ ...doc.data(), id: doc.id })));
    if (list.length) {
      return list[0];
    }
    return null;
  }

  async listProducts(bonDeLivraisonId) {
    const snap = await this.db
      .collection('bonsDeLivraison')
      .doc(bonDeLivraisonId)
      .collection('products')
      .get();
    const list = [];
    snap.forEach((doc) => list.push(new BDLProduct({ ...doc.data(), id: doc.id })));
    return list;
  }

  async upsertProductById(productId, bdlProduct) {
    const transformed = { ...bdlProduct };
    await this.db
      .collection('bonsDeLivraison')
      .doc(bdlProduct.bonDeLivraisonId)
      .collection('products')
      .doc(productId)
      .set(transformed, { merge: true });
  }
}
